import styled from 'styled-components'

interface ContainerProps {
    saleisover: boolean
}

export const Container = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'saleisover',
})<ContainerProps>`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    max-height: 300px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    justify-content: space-between;
    position: relative;
    margin-bottom: 2.5rem;
    background: ${({ saleisover }) => (saleisover ? '#EFF1F4' : '#fff')};
    opacity: ${({ saleisover }) => (saleisover ? 0.5 : 1)};

    @media (max-width: 768px) {
        flex-direction: column;
        max-height: none;
        margin-bottom: 1rem;
    }
`

export const ImageContainer = styled.div`
    max-width: 386px;
    width: 24rem;
    height: 12rem;
    flex-shrink: 0;
    cursor: pointer;

    @media (max-width: 768px) {
        width: 100%;
        height: 200px;
    }
`

export const ImageComponent = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
`

export const WrapperColumn = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`

export const WrapperRow = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;

    @media (max-width: 768px) {
        flex-direction: column;
    }
`

export const DetailsContainer = styled.div`
    flex: 2;
    padding: 10px 20px;
    padding-right: 0px;
    display: flex;
    flex-direction: column;
    min-width: 0;
`

export const ActionContainer = styled.div`
    flex: 1;
    padding: 10px 20px;
    padding-left: 0px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
`

export const Title = styled.h2`
    margin: 0;
    font-size: 36px;
    font-weight: 500;
    max-width: 40ch;
    margin: 0px 5px 10px 0px;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    @media (max-width: 768px) {
        font-size: 24px;
    }
`

export const LocationText = styled.div`
    max-width: 30rem;
    text-transform: uppercase;
    font-size: 12;
    font-weight: bold;
    color: #685612;
    border-radius: 4px;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

export const DateContainer = styled.div`
    margin-top: auto;
    display: flex;
    flex-direction: column;
    margin-bottom: 0.5rem;
`

export const DateDisplay = styled.div`
    margin-top: 10px;
    font-size: 20px;
    font-weight: 400;
    color: #000;
`
